import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Categorie() {
  const [listCategorie, setlistCategorie] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('accessToken')) navigate('/login');

    axios
      .get('/categorie', {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((response) => {
        setlistCategorie(response.data.listCategorie);
      });
  }, []);

  return (
    <React.Fragment>
      <div className="container pt-5">Categorie</div>
      <Link to="/createcategorie" className="btn btn-primary">
        Nouveau Categorie
      </Link>

      <table className="table table-hover">
        <thead>
          <tr>
            <th>Nom </th>
            <th>action</th>
          </tr>
        </thead>
        <tbody>
          {listCategorie.map((categorie, key) => {
            return (
              <tr key={key}>
                <td> {categorie.name} </td>
                <td>
                  <i className="fa fa-fa-edit"></i>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </React.Fragment>
  );
}

export default Categorie;
